$shm_mentionstat_task $shm_service_dashboard
	task_id \
	task_title \
	task_mode \edit
	task_title_draft? \
	task_title_save? null
	pages <= task_pages /
	form_query? \
	form_excluded_words? \
	form_date_from? \
	form_date_to? \
	form_country? \
	form_language? \
	form_search_type? \
	form_tags? \
	form_category? \
	form_social_files? /File
	form_mass_files? /File
	form_social_existing_title \
	form_mass_existing_title \
	form_submit_title \Добавить
	form_submit? null
	form_reset? null
	Edit_page $mol_page
		title_content /
			<= Dashboard_head
		tools /
		body /
			<= Form $shm_mentionstat_form
				query? <=> form_query? \
				excluded_words? <=> form_excluded_words? \
				date_from? <=> form_date_from? \
				date_to? <=> form_date_to? \
				country? <=> form_country? \
				language? <=> form_language? \
				search_type? <=> form_search_type? \
				tags? <=> form_tags? \
				category? <=> form_category? \
				social_files? <=> form_social_files? /File
				mass_files? <=> form_mass_files? /File
				social_existing_title <= form_social_existing_title \
				mass_existing_title <= form_mass_existing_title \
				submit_title <= form_submit_title
				submit? <=> form_submit? null
				reset? <=> form_reset? null
	item_ids /
	item_query* \
	item_excluded* \
	item_period* \
	item_country* \
	item_language* \
	item_social* \
	item_mass* \
	item_type* \
	item_tags* \
	item_category* \
	item_edit*? null
	item_delete*? null
	merge_title \Сформировать таблицу
	merge_enabled false
	merge_start? null
	status_text \
	Items_page $shm_mentionstat_items
		item_ids <= item_ids
		item_query* <= item_query* \
		item_excluded* <= item_excluded* \
		item_period* <= item_period* \
		item_country* <= item_country* \
		item_language* <= item_language* \
		item_social* <= item_social* \
		item_mass* <= item_mass* \
		item_type* <= item_type* \
		item_tags* <= item_tags* \
		item_category* <= item_category* \
		item_edit*? <=> item_edit*? null
		item_delete*? <=> item_delete*? null
		merge_title <= merge_title
		merge_enabled <= merge_enabled
		merge_start? <=> merge_start? null
		status_text <= status_text
	result_rows /
	query_table null
	chart_rows /
	chart_group? \day
	Report_page $mol_page
		title_content /
			<= Dashboard_head
		tools <= report_tools /
		body /
			<= Result $mol_view
				sub <= result_rows
	Chart $shm_mentionstat_chart
		rows <= chart_rows
		group? <=> chart_group? \day
	Table $shm_wordstat_table
		table <= query_table
	Empty $mol_view
		sub / \Нет данных для выбранных фильтров
	report_tools /
	Csv_download $mol_button_download
		title \Скачать csv
		blob <= csv_blob null
		file_name <= csv_file_name \mentionstat.csv
	csv_blob null
	csv_file_name \mentionstat.csv
	filter_date_from? \
	filter_date_to? \
	query_values /
	query_all? false
	query_checked*? false
	query_only*? null
	scope_values /
	scope_all? false
	scope_checked*? false
	scope_only*? null
	country_values /
	country_all? false
	country_checked*? false
	country_only*? null
	language_values /
	language_all? false
	language_checked*? false
	language_only*? null
	type_values /
	type_all? false
	type_checked*? false
	type_only*? null
	category_values /
	category_all? false
	category_checked*? false
	category_only*? null
	filter_reset? null
	Filters_page $shm_mentionstat_filter_panel
		date_from? <=> filter_date_from? \
		date_to? <=> filter_date_to? \
		query_values <= query_values
		query_all? <=> query_all? false
		query_checked*? <=> query_checked*? false
		query_only*? <=> query_only*? null
		scope_values <= scope_values
		scope_all? <=> scope_all? false
		scope_checked*? <=> scope_checked*? false
		scope_only*? <=> scope_only*? null
		country_values <= country_values
		country_all? <=> country_all? false
		country_checked*? <=> country_checked*? false
		country_only*? <=> country_only*? null
		language_values <= language_values
		language_all? <=> language_all? false
		language_checked*? <=> language_checked*? false
		language_only*? <=> language_only*? null
		type_values <= type_values
		type_all? <=> type_all? false
		type_checked*? <=> type_checked*? false
		type_only*? <=> type_only*? null
		category_values <= category_values
		category_all? <=> category_all? false
		category_checked*? <=> category_checked*? false
		category_only*? <=> category_only*? null
		reset? <=> filter_reset? null
	Dashboard_head $shm_service_dashboard_head
		title? <=> task_title_draft? \
		title_save? <=> task_title_save? null
		edit? <=> mode_edit? null
		view? <=> mode_view? null
		view_visible <= mode_view_enabled
		view_enabled <= mode_view_enabled
		edit_color <= mode_edit_color \
		view_color <= mode_view_color \
	mode_edit? null
	mode_view? null
	mode_edit_color \
	mode_view_color \
	mode_view_enabled false
